module.exports = __webpack_public_path__ + "DiabeCare_logoH__1_.19cdd998b3f477f4e44f1b78de19bdc4.png";